import { Component, OnInit, Input } from '@angular/core';
import { Vehicle } from '@pos-app/data';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-vehicle-details',
    templateUrl: './vehicle-details.component.html',
    styleUrls: ['./vehicle-details.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule]
})
export class VehicleDetailsComponent implements OnInit {
  @Input() selectedVehicle: Vehicle;
  public vehicleDetailsForm: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {

  }

  ngOnInit() {
    this.vehicleDetailsForm = this.formBuilder.group({
      id: [''],
      registration: [''],
      stateOfRegistration: [''],
      vin: [''],
      description: ['']
    });
  }

}

